(() => {
  "use strict";
  const initialized = new WeakSet();
  function initialize(root) {
    root.querySelectorAll(".site-header [data-disclosure-locale]").forEach((element) => {
      if (initialized.has(element)) return;
      const toggle = element.querySelector("[data-disclosure-toggle]");
      const list = element.querySelector("[data-disclosure-list]");
      const input = element.querySelector("[data-disclosure-input]");
      const form = element.closest("form");
      if (!toggle || !list || !input || !form) return;
      initialized.add(element);
      function setOpen(open) {
        toggle.setAttribute("aria-expanded", String(open));
        list.classList.toggle("disclosure-list--visible", open);
      }
      toggle.addEventListener("click", () => setOpen(toggle.getAttribute("aria-expanded") !== "true"));
      element.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          setOpen(false);
          toggle.focus();
        }
      });
      element.addEventListener("focusout", (event) => {
        if (event.relatedTarget && !element.contains(event.relatedTarget)) setOpen(false);
      });
      document.addEventListener("click", (event) => {
        if (element.isConnected && !element.contains(event.target)) setOpen(false);
      });
      element.querySelectorAll("[data-disclosure-option]").forEach((option) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          input.value = option.dataset.value;
          if (typeof form.requestSubmit === "function") form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
        });
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize(document), { once: true });
  } else initialize(document);
  document.addEventListener("shopify:section:load", () => initialize(document));
})();
